import { render, staticRenderFns } from "./OpsBrandsWithAssociationItem.vue?vue&type=template&id=69661ddd&"
import script from "./OpsBrandsWithAssociationItem.vue?vue&type=script&lang=js&"
export * from "./OpsBrandsWithAssociationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports